import { Fragment, useCallback, useEffect, useState } from "react"
import { Table } from "common/Table/Table"
import { exportToCSV } from "utils/funcs"
import UserService from "services/user.service"
import swal from "sweetalert"
import { useNotifications } from "hooks/useNotification"

const service = new UserService()

export const Onboarding = () => {
  const columns = [
    {
      key: "companyName",
      dbColName: "company",
      title: "Company Name",
      render: (company) => company["companyName"],
    },
    {
      key: "iAmPartOfCompany",
      dbColName: "company",
      title: "I am part of company",
      render: (company) => company["iAmPartOfCompany"],
    },
    {
      key: "logo",
      dbColName: "company",
      title: "Logo",
      render: (company) => (
        <a href={company["companyLogo"]} target="_blank" rel="noreferrer">
          <img
            src={company["companyLogo"]}
            alt="companyLogo"
            className="object-cover w-12 h-12 rounded-full"
          />
        </a>
      ),
    },
    {
      key: "divisionOrBrandName",
      dbColName: "company",
      title: "Division or Brand Name",
      render: (company) => company["divisionOrBrandName"],
    },
    {
      key: "fullName",
      dbColName: "admin",
      render: (admin) => admin["fullName"],
      title: "Full Name",
    },
    {
      key: "email",
      dbColName: "admin",
      render: (admin) => admin["email"],
      title: "Email",
    },
    {
      key: "phone",
      dbColName: "admin",
      render: (admin) => admin["phone"],
      title: "Phone",
    },
    {
      key: "jobTitle",
      dbColName: "admin",
      title: "Job Title",
      render: (admin) => admin["jobTitle"],
    },
    {
      key: "website",
      dbColName: "social",
      title: "Website",
      render: (social) => social["website"],
    },
    {
      key: "linkedInPage",
      dbColName: "social",
      title: "LinkedIn Page",
      render: (social) => social["linkedInPage"],
    },
    {
      key: "facebookPage",
      dbColName: "social",
      render: (social) => social["facebookPage"],
    },
    {
      key: "instagramPage",
      dbColName: "social",
      render: (social) => social["instagramPage"],
    },
    {
      key: "talendLookingFor",
      dbColName: "needs",
      title: "Talent Looking For",
      render: (needs) => needs["talendLookingFor"],
    },
    {
      key: "traineesCountPerWeek",
      dbColName: "needs",
      title: "Trainees Count Per Week",
      render: (needs) => needs["traineesCountPerWeek"],
    },
    {
      key: "recruitingArea",
      dbColName: "needs",
      title: "Recruiting Area",
      render: (needs) => needs["recruitingArea"],
    },
    {
      key: "idealCandidateProfile",
      dbColName: "needs",
      title: "Ideal Candidate Profile",
      render: (needs) => needs["idealCandidateProfile"],
    },
    {
      key: "action",
      freeze: true,
      freezeIndex: "right-0",
      title: "action",
      render: (row) => {
        return (
          <button
            type="button"
            onClick={() => handleDelete(row._id)}
            className="pl-3 text-right text-red-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
              />
            </svg>
          </button>
        )
      },
    },
  ]

  const [data, setData] = useState([])
  const [exporting, setExporting] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 100,
  })

  const { successMessage } = useNotifications()

  const fetchData = useCallback(() => {
    setLoading(true)
    service
      .getOnboarding(pagination)
      .then((resp) => {
        setData(resp.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [pagination])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const handleDelete = (id: string) => {
    swal({
      title: "Are you sure, you want to delete this onboarding?",
      icon: "warning",
      className: "w-[500px]",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Delete",
          className: "bg-primary text-white",
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        service
          .deleteOnboarding(id)
          .then((resp) => {
            successMessage("Onboarding deleted successfully")
            fetchData()
          })
          .catch((err) => {
            console.log(err)
          })
      }
    })
  }

  const handleExport = () => {
    setExporting(true)
    exportToCSV(data, "sale_ads")
    setExporting(false)
  }

  return (
    <Fragment>
      <div className="flex flex-col mb-4 ">
        <h1 className="page-title">
          Onboarding
        </h1>
        <p className="page-subtitle">View all leads</p>
      </div>
      <Table
        data={data}
        loadingData={loading}
        setPagination={setPagination}
        exporting={exporting}
        handleExport={handleExport}
        pagination={pagination}
        totalItems={data.length}
        showSearch={false}
        columns={columns}
      />
    </Fragment>
  )
}
